import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-je',
  templateUrl: './je.component.html',
  styleUrls: ['./je.component.scss']
})
export class JeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
